"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _selectInput = _interopRequireDefault(require("../selectInput/selectInput"));

var _textInput = _interopRequireDefault(require("../textInput/textInput"));

var _checkboxInput = _interopRequireDefault(require("../checkboxInput/checkboxInput"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formGroupModule = _interopRequireDefault(require("./formGroup.module.css"));

var _multiSelectInput = _interopRequireDefault(require("../multiSelectInput/multiSelectInput"));

var _infoTooltip = _interopRequireDefault(require("../infoToolTip/infoTooltip"));

var _dateInput = _interopRequireDefault(require("../dateInput/dateInput"));

var _textAreaInput = _interopRequireDefault(require("../textArea/textAreaInput"));

var _searchableList = _interopRequireDefault(require("../searchableList/searchableList"));

var _index = require("../../../index");

var _dragAndDrop = _interopRequireDefault(require("../dragAndDrop/dragAndDrop"));

var _currencyInput = _interopRequireDefault(require("../currencyInput/currencyInput"));

var _asyncSearchableList = _interopRequireDefault(require("../asyncSearchableList/asyncSearchableList"));

var _fileInput = _interopRequireDefault(require("../fileInput/fileInput"));

var _postcodeSearchableList = _interopRequireDefault(require("../postcodeSearchableList/postcodeSearchableList"));

var _radioButtonGroup = _interopRequireDefault(require("../radioButtonGroup/radioButtonGroup"));

var _buttonRadioGroup = _interopRequireDefault(require("../buttonRadioGroup/buttonRadioGroup"));

var _constants = require("../../../utils/constants");

var _reactI18next = require("react-i18next");

var _resourceKeys = require("../providers/translations/resources/resourceKeys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PlainText = function PlainText(props) {
  var id = props.id,
      label = props.label,
      htmlFor = props.htmlFor;
  return _react.default.createElement("label", {
    id: id ? "".concat(id, "_plain_label") : null,
    className: _formGroupModule.default["control-label"],
    htmlFor: htmlFor
  }, _react.default.createElement("strong", {
    id: id ? "".concat(id, "_plain_label_strong") : null
  }, label));
};

var getInputItem = function getInputItem(variant) {
  if (variant === "searchableList") {
    return _searchableList.default;
  }

  if (variant === "textarea") {
    return _textAreaInput.default;
  }

  if (variant === "date") {
    return _dateInput.default;
  }

  if (variant === "checkbox") {
    return _checkboxInput.default;
  }

  if (variant === "text") {
    return _textInput.default;
  }

  if (variant === "select") {
    return _selectInput.default;
  }

  if (variant === "multiSelect") {
    return _multiSelectInput.default;
  }

  if (variant === "plain") {
    return PlainText;
  }

  if (variant === "creatableSelect") {
    return _index.CreatableSelect;
  }

  if (variant === "asyncSearchableList") {
    return _asyncSearchableList.default;
  }

  if (variant === "postcodeSearchableList") {
    return _postcodeSearchableList.default;
  }

  if (variant === "dragDrop") {
    return _dragAndDrop.default;
  }

  if (variant === 'currency') {
    return _currencyInput.default;
  }

  if (variant === 'checkbox-inline') {
    return _checkboxInput.default;
  }

  if (variant === 'file') {
    return _fileInput.default;
  }

  if (variant === 'radioButtonGroup') {
    return _radioButtonGroup.default;
  }

  if (variant === 'buttonRadioGroup') {
    return _buttonRadioGroup.default;
  }

  return PlainText;
};

function findCol(word, str) {
  return RegExp('\\b' + word + '\\b').test(str);
}

var getRequiredClassName = function getRequiredClassName(required, style) {
  if (!required) {
    return "";
  }

  return style === _constants.secondaryVariantStyle ? _formGroupModule.default["required-secondary-label"] : _formGroupModule.default["required-label"];
};

var getRequiredInlineClassName = function getRequiredInlineClassName(style) {
  return style === _constants.secondaryVariantStyle ? _formGroupModule.default["required-secondary-checkbox"] : _formGroupModule.default["required-checkbox"];
};

var calculateResponsibleCharSizes = function calculateResponsibleCharSizes(labelSize, inputSize) {
  var inputArray = labelSize.split(" ");
  var inputMatcher = labelSize.match(/[0-9]+/);

  if (inputArray && inputArray.length >= 2 && inputMatcher && inputMatcher.length > 0) {
    return "col-sm-offset-".concat(inputMatcher[0]);
  } else {
    var label = labelSize.replace(/\D/g, "");
    var input = inputSize.replace(/\D/g, "");

    if (findCol('offset', labelSize) && inputArray.length === 1) {
      return "col-sm-".concat(label);
    }

    var result = parseInt(label) + parseInt(input);

    if (result && result <= 12) {
      var _responsibleSizes;

      var responsibleSizes = (_responsibleSizes = {}, _defineProperty(_responsibleSizes, "col-sm-offset-".concat(label), findCol('sm', labelSize)), _defineProperty(_responsibleSizes, "col-md-offset-".concat(label), findCol('md', labelSize)), _defineProperty(_responsibleSizes, "col-lg-offset-".concat(label), findCol('lg', labelSize)), _responsibleSizes);
      return Object.keys(responsibleSizes).filter(function (key) {
        return responsibleSizes[key];
      }).toString();
    }
  }

  return "";
};

var FormGroup = function FormGroup(props) {
  var id = props.id,
      variant = props.variant,
      inputProps = props.inputProps,
      label = props.label,
      labelSize = props.labelSize,
      inputSize = props.inputSize,
      infoText = props.infoText,
      errorMessage = props.errorMessage,
      groupShape = props.groupShape,
      helpText = props.helpText,
      inline = props.inline,
      maxCharacters = props.maxCharacters,
      responsibleMaxChar = props.responsibleMaxChar,
      hasInlineElements = props.hasInlineElements,
      inlineGroupElements = props.inlineGroupElements,
      _props$formGroupTestI = props.formGroupTestId,
      formGroupTestId = _props$formGroupTestI === void 0 ? 'form-group' : _props$formGroupTestI,
      _props$formGroupInput = props.formGroupInputTestId,
      formGroupInputTestId = _props$formGroupInput === void 0 ? 'form-group-input' : _props$formGroupInput,
      _props$formGroupLabel = props.formGroupLabelTestId,
      formGroupLabelTestId = _props$formGroupLabel === void 0 ? 'form-group-label' : _props$formGroupLabel,
      _props$requiredStyle = props.requiredStyle,
      requiredStyle = _props$requiredStyle === void 0 ? _constants.primaryVariantStyle : _props$requiredStyle;
  var InputItem = getInputItem(variant);
  var displayCharactersLimit = maxCharacters && variant === 'textarea';

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  if (variant === 'checkbox-inline') {
    var checkboxLabel = label;

    if (inputProps.required) {
      checkboxLabel = _react.default.createElement(_react.default.Fragment, null, label, _react.default.createElement("span", {
        id: id ? "".concat(id, "_form_group_label") : null,
        className: "".concat(getRequiredInlineClassName(requiredStyle))
      }));
    }

    return _react.default.createElement("div", {
      id: id ? "".concat(id, "_form_group") : null,
      className: (0, _classnames.default)(inline ? "" : "row", _formGroupModule.default["form-group"], errorMessage ? _formGroupModule.default["has-error"] : "", _themeModule.default.arag)
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_form_group_size") : null,
      className: "".concat(inputSize)
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_form_group_wrapper") : null,
      style: {
        display: 'inline-block'
      }
    }, _react.default.createElement(_checkboxInput.default, _extends({
      id: id ? "".concat(id, "_form_group_checkbox") : null,
      label: checkboxLabel
    }, inputProps))), errorMessage && _react.default.createElement("small", {
      id: id ? "".concat(id, "_error_message") : null,
      className: _formGroupModule.default["text-danger"]
    }, errorMessage)));
  }

  return _react.default.createElement("div", {
    id: id ? id : null
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group") : null,
    "data-testid": formGroupTestId,
    className: (0, _classnames.default)(inline ? "" : "row", _formGroupModule.default["form-group"], errorMessage ? _formGroupModule.default["has-error"] : "", _themeModule.default.arag)
  }, !groupShape && _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group_required_label") : null,
    className: "".concat(labelSize, " ").concat(getRequiredClassName(inputProps.required, requiredStyle)),
    "data-testid": formGroupLabelTestId
  }, label && _react.default.createElement("label", {
    id: id ? "".concat(id, "_form_group_label") : null,
    className: _formGroupModule.default["control-label"]
  }, label)), _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group_wrapper") : null,
    className: "".concat(inputSize),
    "data-testid": formGroupInputTestId
  }, _react.default.createElement(InputItem, inputProps), errorMessage && _react.default.createElement("small", {
    id: id ? "".concat(id, "_error_message") : null,
    className: _formGroupModule.default["text-danger"]
  }, errorMessage)), groupShape && groupShape === "reverse" && _react.default.createElement("div", {
    id: id ? "".concat(id, "_group_shape") : null,
    className: "".concat(labelSize, " ").concat(getRequiredClassName(inputProps.required, requiredStyle))
  }, label && _react.default.createElement("label", {
    className: _formGroupModule.default["control-label"]
  }, label)), infoText && _react.default.createElement(_infoTooltip.default, {
    id: id ? "".concat(id, "_info_tooltip") : null,
    text: infoText
  }), hasInlineElements && _react.default.createElement(_react.default.Fragment, null, inlineGroupElements)), displayCharactersLimit && _react.default.createElement("span", {
    id: id ? "".concat(id, "_character_limit") : null,
    className: (0, _classnames.default)(responsibleMaxChar ? "".concat(calculateResponsibleCharSizes(labelSize, inputSize)) : "", responsibleMaxChar ? _formGroupModule.default['help-textarea'] : "", _formGroupModule.default["help-block"])
  }, "".concat(maxCharacters - (inputProps.value ? inputProps.value : '').length > 0 ? maxCharacters - (inputProps.value ? inputProps.value : '').length : 0, " ").concat(t(_resourceKeys.resourceKeys.charactersRemaining.key))), helpText && _react.default.createElement("span", {
    id: id ? "".concat(id, "_help_text") : null,
    className: _formGroupModule.default["help-block"]
  }, helpText));
};

FormGroup.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Specifies the variant of the component.Variant maps to corresponding component. eg: select -> SelectInput */
  variant: _propTypes.default.oneOf(["searchableList", "textarea", "date", "checkbox", "text", "select", "multiSelect", "plain", "creatableSelect", "dragDrop", "currency", "asyncSearchableList", "postcodeSearchableList", "checkbox-inline", "file", "radioButtonGroup", "buttonRadioGroup"]),

  /** Object that must contain all the required props of the selected variant component*/
  inputProps: _propTypes.default.object.isRequired,

  /** String text next to the input */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /** String  that must match a bootstrap grid class: eg: col-sm-3 */
  labelSize: _propTypes.default.string,

  /** String that must match a bootstrap grid class eg: col-sm-7 */
  inputSize: _propTypes.default.string,

  /** String text that will be displayed with the help of an info tooltip */
  infoText: _propTypes.default.string,

  /** String text that will be displayed formGroup as you wish */
  groupShape: _propTypes.default.oneOf(["reverse"]),

  /** String help text that will be displayed under the form group  */
  helpText: _propTypes.default.string,

  /** Boolean indicating that the form group should be displayed inline  */
  inline: _propTypes.default.bool,

  /** Maximum characters for textarea  */
  maxCharacters: _propTypes.default.number,

  /** Responsible sizes for textarea characters  */
  responsibleMaxChar: _propTypes.default.bool,

  /** Boolean indicating that the form group should be displayed inline  */
  hasInlineElements: _propTypes.default.bool,

  /** Initial group elements  */
  inlineGroupElements: _propTypes.default.object,

  /** Test ID for form group*/
  formGroupTestId: _propTypes.default.string,

  /** Test ID for form group label*/
  requiredStyle: _propTypes.default.oneOf([_constants.primaryVariantStyle, _constants.secondaryVariantStyle]),

  /** String text that specifies the test id for the form group input */
  formGroupInputTestId: _propTypes.default.string,

  /** String text that specifies the test id for the form group label */
  formGroupLabelTestId: _propTypes.default.string
};
var _default = FormGroup;
exports.default = _default;